import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { BOOKING_URL, trackBookingClick } from "@/lib/booking";

export function Eyebrow({ children, className = "", light = false }) {
  return <p className={`eyebrow ${light ? "!text-gold" : ""} ${className}`}>{children}</p>;
}

export function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-site px-5 sm:px-8 lg:px-12 ${className}`}>{children}</div>;
}

export function Section({ children, className = "", id, dark = false }) {
  return (
    <section id={id} className={`${dark ? "bg-ink on-dark" : ""} py-20 md:py-28 lg:py-32 ${className}`}>
      {children}
    </section>
  );
}

/** Link to a localized route key */
export function LLink({ to, params, children, className = "", ...rest }) {
  const { path } = useLang();
  return (
    <Link to={path(to, params)} className={className} {...rest}>
      {children}
    </Link>
  );
}

export function BookButton({ className = "", variant = "accent", label, testId = "book-button", href }) {
  const { t, lang } = useLang();
  return (
    <a
      href={href || BOOKING_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onClick={() => trackBookingClick(testId, lang)}
      className={`btn btn-${variant} ${className}`}
    >
      {label || t.nav.book}
      <ArrowUpRight size={14} strokeWidth={1.5} />
    </a>
  );
}

export function ArrowLink({ children, className = "", light = false, ...rest }) {
  return (
    <span className={`group inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] ${light ? "text-bone" : "text-charcoal"} ${className}`} {...rest}>
      <span className="link-line">{children}</span>
      <ArrowUpRight size={14} strokeWidth={1.5} className="transition-transform duration-500 ease-editorial group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
    </span>
  );
}

export function SectionHeader({ eyebrow, title, text, light = false, className = "", align = "left", children }) {
  return (
    <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-2xl ${className}`}>
      {eyebrow && <Eyebrow light={light} className="mb-5">{eyebrow}</Eyebrow>}
      {title && <h2 className={`font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight ${light ? "text-bone" : "text-charcoal"}`}>{title}</h2>}
      {text && <p className={`mt-6 text-base md:text-lg leading-relaxed ${light ? "text-bone/70" : "text-charcoal/70"}`}>{text}</p>}
      {children}
    </div>
  );
}
